/** @file tilePxOf: a profile's authored pixels per unit per world axis, defaulting to pixelsPerUnit (22.1). */
import type { Profile } from '@zilo/pose3d-format/types/profile';

/** `profile.tilePx` (`[across, depth, height]`, CR-006 22.1) or `[pixelsPerUnit, pixelsPerUnit, pixelsPerUnit]`. */
export function tilePxOf(profile: Pick<Profile, 'pixelsPerUnit' | 'tilePx'>): [number, number, number] {
  const ppu = profile.pixelsPerUnit;
  return profile.tilePx === undefined ? [ppu, ppu, ppu] : [profile.tilePx[0], profile.tilePx[1], profile.tilePx[2]];
}
